import { render, staticRenderFns } from "./SortList.vue?vue&type=template&id=27b3da91&scoped=true"
import script from "./SortList.vue?vue&type=script&lang=js"
export * from "./SortList.vue?vue&type=script&lang=js"
import style0 from "./SortList.vue?vue&type=style&index=0&id=27b3da91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3da91",
  null
  
)

export default component.exports